// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AFBMTcSKEOf0VKdjLuBh {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  width: 100%;
  max-width: 100%;
}
.AFBMTcSKEOf0VKdjLuBh .QIOhfhUfe_hJgJUTadYi {
  font-size: 0.875rem;
  line-height: 1.0625rem;
  font-weight: 500;
  color: #ededed;
}
.AFBMTcSKEOf0VKdjLuBh .TSkh2zgyKez4CCLTLUvN {
  color: #a0a0a0;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9 {
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
  width: calc(100% - 30px);
  white-space: nowrap;
  padding: 8px 12px;
  border: 1px solid #543e79;
  border-radius: 10px;
  background-color: rgba(50, 50, 50, 0.8);
  transition: all 0.3s;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9:hover {
  cursor: pointer;
  transition: all 0.3s;
  background-color: #2d2d2d;
  border-color: #6439ab;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9:hover svg {
  transition: all 0.3s;
  fill: #cbcbcb;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9:hover svg * {
  transition: all 0.3s;
  fill: #cbcbcb;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9:hover .Hf_rG57oTUrqAQf2BKt4 {
  transition: all 0.3s;
  color: #cbcbcb !important;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9:focus-within {
  transition: all 0.3s;
  border-color: #8d56e8;
  background-color: #2d2d2d;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9:focus-within svg {
  transition: all 0.3s;
  fill: #fff;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9:focus-within svg * {
  transition: all 0.3s;
  fill: #fff;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9:active {
  transition: all 0.3s;
  border-color: #543e79;
  background-color: rgba(50, 50, 50, 0.8);
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9:active svg {
  transition: all 0.3s;
  fill: #fff;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9:active svg * {
  transition: all 0.3s;
  fill: #fff;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9 .LgIKqSDefTcetlfGDqpH {
  display: flex;
  min-width: 32px;
  min-height: 32px;
  align-items: center;
  justify-content: center;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9 .LgIKqSDefTcetlfGDqpH svg {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  transition: all 0.3s;
  fill: #b6b6b6;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9 .LgIKqSDefTcetlfGDqpH svg * {
  transition: all 0.3s;
  fill: #b6b6b6;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9 .g0yadjdW47wjFCQ7q02J {
  display: flex;
  align-items: center;
  font-size: 1rem;
  line-height: 1.1875rem;
  font-weight: 400;
  color: #fff;
  transition: all 0.3s;
  min-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9 .Hf_rG57oTUrqAQf2BKt4 {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: unset !important;
  padding: 0;
  border: unset !important;
  outline: unset !important;
  font-size: 1rem !important;
  line-height: 1.1875rem !important;
  font-weight: 400 !important;
  background: transparent !important;
  background-color: transparent !important;
  transition: all 0.3s;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff !important;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9 .Hf_rG57oTUrqAQf2BKt4::placeholder {
  color: #b6b6b6 !important;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9 .Hf_rG57oTUrqAQf2BKt4:placeholder-shown {
  color: #b6b6b6 !important;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9 .Hf_rG57oTUrqAQf2BKt4:focus, .AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9 .Hf_rG57oTUrqAQf2BKt4:active {
  outline: unset;
  transition: all 0.3s;
  color: #fff !important;
}
.AFBMTcSKEOf0VKdjLuBh .mamrmv5zspZcR1gtG3D9 .Hf_rG57oTUrqAQf2BKt4:disabled {
  transition: all 0.3s;
  color: #636363 !important;
  cursor: not-allowed;
}
.AFBMTcSKEOf0VKdjLuBh .A6fkQiWYwaCAjNvQQyH5 {
  transition: all 0.3s;
  border-color: #382a50;
  background-color: rgba(50, 50, 50, 0.8);
}
.AFBMTcSKEOf0VKdjLuBh .A6fkQiWYwaCAjNvQQyH5:hover, .AFBMTcSKEOf0VKdjLuBh .A6fkQiWYwaCAjNvQQyH5:focus, .AFBMTcSKEOf0VKdjLuBh .A6fkQiWYwaCAjNvQQyH5:active {
  transition: all 0.3s;
  cursor: not-allowed;
  border-color: #382a50;
  background-color: rgba(50, 50, 50, 0.8);
}
.AFBMTcSKEOf0VKdjLuBh .A6fkQiWYwaCAjNvQQyH5 svg {
  transition: all 0.3s;
  fill: #636363;
}
.AFBMTcSKEOf0VKdjLuBh .A6fkQiWYwaCAjNvQQyH5 svg * {
  transition: all 0.3s;
  fill: #636363;
}
.AFBMTcSKEOf0VKdjLuBh .A6fkQiWYwaCAjNvQQyH5 .g0yadjdW47wjFCQ7q02J {
  transition: all 0.3s;
  color: #636363;
}
.AFBMTcSKEOf0VKdjLuBh .oYcFpK1j8u7rQYoVxGzA {
  transition: all 0.3s;
  border-color: #f2164b;
  background-color: #2d2d2d;
}
.AFBMTcSKEOf0VKdjLuBh .oYcFpK1j8u7rQYoVxGzA svg {
  transition: all 0.3s;
  fill: #fff;
}
.AFBMTcSKEOf0VKdjLuBh .oYcFpK1j8u7rQYoVxGzA svg * {
  transition: all 0.3s;
  fill: #fff;
}
.AFBMTcSKEOf0VKdjLuBh .oYcFpK1j8u7rQYoVxGzA .Hf_rG57oTUrqAQf2BKt4 {
  transition: all 0.3s;
  color: #fff;
}
.AFBMTcSKEOf0VKdjLuBh .VUjEwieGuVQaDAYe_4cL {
  transition: all 0.3s;
  border-color: #0eaf00;
  background-color: #2d2d2d;
}
.AFBMTcSKEOf0VKdjLuBh .VUjEwieGuVQaDAYe_4cL svg {
  transition: all 0.3s;
  fill: #fff;
}
.AFBMTcSKEOf0VKdjLuBh .VUjEwieGuVQaDAYe_4cL svg * {
  transition: all 0.3s;
  fill: #fff;
}
.AFBMTcSKEOf0VKdjLuBh .VUjEwieGuVQaDAYe_4cL .Hf_rG57oTUrqAQf2BKt4 {
  transition: all 0.3s;
  color: #fff;
}
.AFBMTcSKEOf0VKdjLuBh .HWTCzkuZWrtK3AcfKe73,
.AFBMTcSKEOf0VKdjLuBh .smoDJbsDBT7piEcwQ5Ky {
  width: 100%;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  font-weight: 500;
}
.AFBMTcSKEOf0VKdjLuBh .HWTCzkuZWrtK3AcfKe73 {
  color: #f2164b;
}
.AFBMTcSKEOf0VKdjLuBh .smoDJbsDBT7piEcwQ5Ky {
  color: #0eaf00;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/Input/Input.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAAF;AAEE;EACE,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cCaY;ADbhB;AAGE;EACE,cCsBO;ADvBX;AAIE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uCAAA;EACA,oBAAA;AAFJ;AAII;EACE,eAAA;EACA,oBAAA;EACA,yBCkBS;EDjBT,qBC3BO;ADyBb;AAIM;EACE,oBAAA;EACA,aCNG;ADIX;AAIQ;EACE,oBAAA;EACA,aCVC;ADQX;AAMM;EACE,oBAAA;EACA,yBAAA;AAJR;AAQI;EACE,oBAAA;EACA,qBC7CO;ED8CP,yBCJS;ADFf;AAQM;EACE,oBAAA;EACA,UC3CA;ADqCR;AAQQ;EACE,oBAAA;EACA,UC/CF;ADyCR;AAWI;EACE,oBAAA;EACA,qBChEO;EDiEP,uCAAA;AATN;AAWM;EACE,oBAAA;EACA,UC3DA;ADkDR;AAWQ;EACE,oBAAA;EACA,UC/DF;ADsDR;AAcI;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAZN;AAcM;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EAEA,aC7EQ;ADgEhB;AAeQ;EACE,oBAAA;EACA,aCjFM;ADoEhB;AAkBI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,WCjGE;EDkGF,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4BAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,iCAAA;EACA,2BAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EAGA,sBAAA;AAnBN;AAsBM;EACE,yBAAA;AApBR;AAuBM;EACE,yBAAA;AArBR;AAwBM;EAEE,cAAA;EACA,oBAAA;EACA,sBAAA;AAvBR;AA0BM;EACE,oBAAA;EACA,yBAAA;EACA,mBAAA;AAxBR;AA6BE;EACE,oBAAA;EACA,qBC3JS;ED4JT,uCAAA;AA3BJ;AA6BI;EAGE,oBAAA;EACA,mBAAA;EACA,qBCnKO;EDoKP,uCAAA;AA7BN;AAgCI;EACE,oBAAA;EACA,aCpJK;ADsHX;AAgCM;EACE,oBAAA;EACA,aCxJG;AD0HX;AAkCI;EACE,oBAAA;EACA,cC9JK;AD8HX;AAoCE;EACE,oBAAA;EACA,qBCnIM;EDoIN,yBCpJW;ADkHf;AAoCI;EACE,oBAAA;EACA,UC3LE;ADyJR;AAoCM;EACE,oBAAA;EACA,UC/LA;AD6JR;AAsCI;EACE,oBAAA;EACA,WCrME;ADiKR;AAwCE;EACE,oBAAA;EACA,qBC3JQ;ED4JR,yBCzKW;ADmIf;AAwCI;EACE,oBAAA;EACA,UChNE;AD0KR;AAwCM;EACE,oBAAA;EACA,UCpNA;AD8KR;AA0CI;EACE,oBAAA;EACA,WC1NE;ADkLR;AA4CE;;EAEE,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AA1CJ;AA6CE;EACE,cCpLM;ADyIV;AA8CE;EACE,cC3LQ;AD+IZ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `AFBMTcSKEOf0VKdjLuBh`,
	"label": `QIOhfhUfe_hJgJUTadYi`,
	"disabledLabel": `TSkh2zgyKez4CCLTLUvN`,
	"inputElementContainer": `mamrmv5zspZcR1gtG3D9`,
	"inputElement": `Hf_rG57oTUrqAQf2BKt4`,
	"iconContainer": `LgIKqSDefTcetlfGDqpH`,
	"subtext": `g0yadjdW47wjFCQ7q02J`,
	"disabledInputContainer": `A6fkQiWYwaCAjNvQQyH5`,
	"erroredInputContainer": `oYcFpK1j8u7rQYoVxGzA`,
	"successInputContainer": `VUjEwieGuVQaDAYe_4cL`,
	"errorMessage": `HWTCzkuZWrtK3AcfKe73`,
	"successMessage": `smoDJbsDBT7piEcwQ5Ky`
};
export default ___CSS_LOADER_EXPORT___;
